import { SupplierItemInsight } from '@retail/products/types';

const dummySupplierItemInsight = new SupplierItemInsight({
  mgItemNumber: 0,
  finfoNumber: 0,
  primaryText: '',
  secondaryText: '',
  supplier: { mgSupplierId: 0, name: '' },
  etimKl: '',
  environment: {
    svanen: { svanenCertificateId: '' },
    euBlomman: { euBlommanCertificateId: '' },
    basta: true,
    bastaBeta: true,
    bastaDeklarerad: true,
    sundahusAssessment: { sundahusAssessment: '' },
    blueAngel: true,
    bvb: {
      bvbAssessmentTotal: '',
      bvbAssessmentUrl: '',
      bvbCertificateId: '',
    },
    ebvd: true,
    euEcoLabel: true,
    braMiljoval: true,
    fscCertified: true,
    pefcCertified: true,
  },
  climate: {
    gtin: '',
    epdProductName: '',
    epdOwner: '',
    epdFunctionalUnit: '',
    epdFunctionalUnitWeight: 0,
    epdValidTo: '',
    epdStandard: '',
    epdAssetLink: '',
    epdPublisher: '',
    epdLastModified: '',
    gwp: {
      a1a3FromEpd: 0,
      a1a3FromBoverket: 0,
      a4FromEpd: 0,
      a4FromBoverket: 0,
      a5FromEpd: 0,
      a5FromBoverket: 0,
      c1c4: 0,
      d: 0,
    },
    source: '',
  },
  documentation: {
    safetyDataSheet: true,
    productDataSheet: true,
    userManual: true,
    explodedView: true,
    productCatalog: true,
    performanceDeclaration: true,
    installationInstructions: true,
    environmentProductDeclaration: true,
    constructionProductDeclaration: true,
    certificate: true,
    operationAndMaintenance: true,
    disassemblyInstructions: true,
  },
  pictureData: {
    productImageSingle: true,
    inContextProductImage: true,
    productInActionImage: true,
    productImageGroup: true,
    brandLogo: true,
    lineDrawing: true,
    colorSampleImage: true,
    productSurfaceImage: true,
  },
});

function getKeyPathsFromObject(shape: unknown, prefix = ''): string[] {
  if (shape === null || shape === undefined) return [];

  if (typeof shape !== 'object') return prefix ? [prefix] : [];

  return Object.entries(shape as Record<string, unknown>).flatMap(([k, v]) => {
    const nextPrefix = prefix ? `${prefix}.${k}` : k;
    return getKeyPathsFromObject(v, nextPrefix);
  });
}

export const supplierItemInsightKeyPaths = getKeyPathsFromObject(dummySupplierItemInsight);
